import * as Sentry from "@sentry/react";
import { isInAppBrowserNativeBridgeNoise } from "./browser-error-noise";

declare const __GAOLE_BUILD_SHA__: string;
declare const __GAOLE_BUILD_TIME__: string;

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN?.trim();
  if (!import.meta.env.PROD || !dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT?.trim() || "production",
    release: __GAOLE_BUILD_SHA__,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.05),
    beforeSend(event) {
      if (isInAppBrowserNativeBridgeNoise(event)) return null;
      return event;
    },
  });
}

export { Sentry };
